import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { convertGoldStarUserLogsResponse } from './shared/convert'
import keys from './shared/keys'
import { GoldStarUserLogsResponse } from './shared/response'

export function useGoldStarChanges(
  companyId: string | undefined,
  month: string,
  year: string
) {
  const { server } = useServer()

  return useQuery({
    queryKey: keys.changes(companyId, month, year),
    queryFn: fetchUserChanges,
    enabled: !!companyId,
    refetchOnMount: 'always',
  })

  async function fetchUserChanges() {
    if (!companyId) {
      throw new Error('Company id invalid')
    }

    const response = await server.get<GoldStarUserLogsResponse>(
      `/v2/managers/me/goldstars/${companyId}/logs?month=${month}&year=${year}`
    )

    return convertGoldStarUserLogsResponse(response)
  }
}
